import * as React from 'react';
import * as styles from './Promotions.css';
import { IPromotion } from '../../types/builder/promotions';
import { ModalWindow, useDeviceType } from '@cian/ui-kit';
import { PromotionDetail, PromotionItem } from './components';

interface IPromotionsProps {
  items: IPromotion[];
  phoneButton: React.ReactNode;
}

export const Promotions: React.FC<IPromotionsProps> = ({ items, phoneButton }) => {
  const [selectedPromotion, setSelectedPromotion] = React.useState<IPromotion>();
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';

  const resetSelectedPromotion = React.useCallback(() => {
    setSelectedPromotion(undefined);
  }, []);

  return (
    <>
      <div className={styles['title']}>Акции и скидки на строительство дома</div>
      <ul className={styles['promotions']}>
        {items.map((promotion, index) => (
          <PromotionItem key={index} {...promotion} onClick={() => setSelectedPromotion(promotion)} />
        ))}
      </ul>
      {selectedPromotion && (
        <ModalWindow
          open
          title={selectedPromotion.title}
          footer={isMobile && phoneButton}
          onClose={resetSelectedPromotion}
          width={776}
          content={<PromotionDetail {...selectedPromotion} phoneButton={phoneButton} />}
          fixed={isMobile}
        />
      )}
    </>
  );
};
